import React, { useContext } from "react";

import {
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";

import { UserContext } from "utils/UserContext";

import PropTypes from "prop-types";

function ScoreTypeButton({ btn }) {
  const mainTheme = useTheme();
  const { selectedScoreType, setSelectedScoreType } = useContext(UserContext);

  return (
    <ListItem
      sx={{
        paddingTop: "5px",
        paddingBottom: "5px",
      }}
    >
      <ListItemButton
        sx={{
          bgcolor:
            selectedScoreType === btn.title
              ? mainTheme.palette.darkBluePrimary.main
              : mainTheme.palette.blackPrimary.main,
          textAlign: "center",
          borderRadius: "1.25rem",
          padding: "5px 0 5px 0",
        }}
        onClick={() => {
          setSelectedScoreType(btn.title);
        }}
      >
        <ListItemText
          sx={{
            margin: "0.65rem",
          }}
          primary={
            <Typography
              sx={{
                fontWeight: 600,
                fontStyle: "italic",
                display: "block",
                textTransform: "uppercase",
              }}
              component="span"
              variant="h5"
              color={mainTheme.palette.whitePrimary.main}
            >
              {btn.title} Score
            </Typography>
          }
          secondary={
            <Typography
              sx={{
                display: "inline",
              }}
              component="span"
              variant="body1"
              color={mainTheme.palette.whitePrimary.main}
            >
              Score {btn.summary}
            </Typography>
          }
        />
      </ListItemButton>
    </ListItem>
  );
}

ScoreTypeButton.propTypes = {
  btn: PropTypes.shape({
    title: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
  }).isRequired,
};

export default ScoreTypeButton;
